import { Component, Input, OnInit } from '@angular/core';
import { ICombineEngine } from '@app/shared/interfaces';
import { SnapshatComponent } from '../modals/snapshat/snapshat.component';
import { TrackingService, WindowRefService } from '@app/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-price-check',
  templateUrl: './price-check.component.html',
  styleUrls: ['./price-check.component.scss']
})
export class PriceCheckComponent implements OnInit {
  @Input() engine: ICombineEngine;

  constructor(private dialog: MatDialog, private trackingService: TrackingService, private winRef: WindowRefService) { }

  ngOnInit() {
  }

  /**
  * get taux de change
  * @returns number
  */
  get Cpercente(): number {
    return this.winRef.appConfigSite.Cpercente;
  }

  /**
   * get currency
   * @returns string
   */
  get Ccurrency(): string {
    return this.winRef.appConfigSite.Ccurrency;
  }

  /**
  * lang
  * @returns string lang
  */
  get lang(): string {
    return this.winRef.appConfigSite.defaultlangue
  }

  openSnapshat(engine) {
    const dialogRef = this.dialog.open(SnapshatComponent, {
      data: {engine: engine},
      panelClass: 'snapshoot'
    });
    dialogRef.afterClosed().subscribe(result => {
      
    });
    this.trackingService.compare(null);
  }

  get remise() {
    let remise = 100 - (this.prices.Ttc * 100 / this.engine.combine.detailPrice_without_promo.Ttc);
    return Math.round((remise * 100) / 100);
  }
  
  get prices() {
    return this.winRef.appConfigSite.promo ? this.engine.combine.detailPrice : this.engine.combine.detailPrice_without_promo
  }

}
